import { accountingIntegrationContract } from "@common/contracts/accounting-integration.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

export const accountingIntegrationContractClient = getBackendAPIClient(
    accountingIntegrationContract,
);

export const accountingMigrationQueryKeys = {
    all: ["accounting-migration"] as const,
    byEntity: (entityId: number | undefined) =>
        [...accountingMigrationQueryKeys.all, entityId] as const,
    byWorkspace: (workspaceId: string | null) =>
        [
            ...accountingMigrationQueryKeys.all,
            "workspace",
            workspaceId,
        ] as const,
};
